import Vue from 'vue'
import VueRouter from 'vue-router'
import bappebtiRoutes from "../components/bappebti/bappebti.route";

Vue.use(VueRouter)

const routes = [
    {
        path:'/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: "/recognition",
        name: "faceRecognition",
        component: () => import("../views/kmi/Withdrawal.vue"),
    },
    {
        path: "/recognitionTemp",
        name: "faceRecognitionTemp",
        component: () => import("../components/withdrawal/FaceRecognitionTemp.vue"),
    },
    { path: "*", component: () => import("../components/utilsLayout/PageNotFound.vue") },
{
        path: "/document/:id",
        name: "Test",
        component: () => import("../components/DepositConfirmation.vue"),
    },
    {
        path:'',
        component: () => import('../layout/AdminLayout.vue'),
        children:[
            ...bappebtiRoutes,
            {
                path: '/',
                name: 'Dashboard',
                component: () => import('../views/Dashboard.vue'),
                meta : {requiresAuth: true, allowedRoles: [2, 3, 5, 7, 99, 8, 6, 9]}
            },
            //onexchange
            {
                path: "/permission",
                name: "Permission",
                component: () => import("../views/PermissionList.vue"),
                meta:{requiresAuth: true, allowedRoles: [2, 3]}
            },
            // {
            //     path: '/gold-delivery',
            //     name: 'GoldDelivery',
            //     component: () => import('../views/kmi/GoldDelivery.vue'),
            //     beforeEnter: isAuth,
            // },
            // {
            //     path: '/gold-delivery/detail/:id',
            //     name: 'GoldDeliveryDetail',
            //     component: () => import('../views/kmi/GoldDeliveryDetail.vue'),
            //     beforeEnter: isAuth,
            // },
            {
                path: "/permission-detail/:id",
                component: () => import("../views/Permission.vue"),
                meta:{requiresAuth: true, allowedRoles: [2, 3]},
                children: [
                    {
                        path: "",
                        component: () => import("../views/PermissionDetail.vue"),
                    },
                    {
                        path: ":seri",
                        component: () => import("../views/PermissionRealisasi.vue"),
                    },
                    {
                        path: "history/:realisation_id",
                        component: () => import("../views/PermissionHistory.vue"),
                    },
                    {
                        path: "history-detail/:history_id",
                        component: () => import("../views/PermissionHistoryDetail.vue"),
                    },
                ],
            },
            {
                path: '/deposite-onexchange',
                name: 'Deposit onExchange',
                component: () => import('../views/Deposite.vue'),
                meta:{requiresAuth: true, allowedRoles: [2, 3, 5, 7]}
            },
            {
                path: '/user-participant',
                name: 'Participant page',
                component: () => import('../views/kmi/ParticipanPageKMI.vue'),
                meta:{requiresAuth: true, allowedRoles: [2, 3, 5, 7]}
            },
            {
                path: '/user-participant/:id',
                component: () => import('../views/kmi/ParticipantPageKMIDetail.vue'),
                meta:{requiresAuth: true, allowedRoles: [2, 3, 5, 7]},
                children: [
                    {
                        path: '',
                        component: () => import('../views/kmi/ParticipanDetail.vue'),
                        name: 'Participant Detail',
                        meta: {title: 'PC Inventory Detail'}
                    },
                    {
                        path: ':hin',
                        component: () => import('../views/kmi/ParticipanListBlock.vue'),
                        name: 'Participant List Block',
                        meta: {title: 'PC Inventory List Block'}
                    }
                ]
            },
            {
                path: "/add-deposit",
                name: "AddDeposit",
                component: () => import("../views/DepositAddOn.vue"),
                meta:{requiresAuth: true, allowedRoles: [2, 3]}
            },
            {
                path: '/detail-deposit/:id',
                name: 'Detail Deposit',
                component: () => import('../views/DetailDeposite.vue'),
                meta:{isAuth : true, roleAccess:[2, 3, 5, 7]}
            },
            {
                path: "/withdrawalOn",
                name: "WithdrawOn",
                component: () => import("../components/withdrawal/WithdrawOnTemp.vue"),
                meta:{isAuth : true, roleAccess:[2, 3, 5, 7]}
            },
            {
                path: "/add-withdraw",
                name: "Add Withdraw",
                component: () => import("../components/withdrawal/AddWithdrawOn"),
                meta:{isAuth : true, roleAccess:[2, 3, 5]}
            },
            {
                path: "/detail-withdrawal/:id",
                name: "DetailWithdraw",
                component: () => import("../views/Detail.vue"),
                meta:{requiresAuth: true, allowedRoles: [2, 3, 5, 7]}
            },
            {
                path: "/inventory",
                name: "Inventory",
                component: () => import("../views/VmInventory.vue"),
                meta:{requiresAuth: true, allowedRoles: [2, 3, 5, 7]}
            },
            {
                path: "/detail-inventory/:id",
                name: "DetailVMInventory",
                component: () => import("../views/DetailVMinventory.vue"),
                meta:{requiresAuth: true, allowedRoles: [2, 3, 5, 7]}
            },
            
            //offexchange
            {
                path: '/deposite-off',
                name: 'Deposit offExchange',
                component: () => import('../components/deposit/DepositOffexchangeTemp.vue'),
                meta:{requiresAuth: true, allowedRoles: [2, 3, 5, 7]}
            },
            {
                path: "/detail-deposit/:id",
                name: "DetailDeposite",
                component: () => import("../views/DetailDeposite.vue"),
                meta:{requiresAuth: true, allowedRoles: [2, 3, 5, 7]}
            },
            {
                path: "/withdrawalOff",
                name: "WithdrawOff",
                component: () => import("../components/withdrawal/WithdrawalOffexchange.vue"),
                meta:{requiresAuth: true, allowedRoles: [2, 3, 5, 7]}
            },
            {
                path: "/detail-request-withdraw-off-exchange/:id",
                name: "DetailRequestWithdrawOffExchange",
                component: () => import("../components/withdrawal/DetailRequestWithdrawOffExchange.vue"),
                meta:{requiresAuth: true, allowedRoles: [2, 3, 5]}
            },
            {
                path: "/inventoryOff",
                name: "InventoryOff",
                component: () => import("../views/VmInventoryOff.vue"),
                meta:{requiresAuth: true, allowedRoles: [2, 3, 5]}
            },
            {
                path: "/detail-inventory-off/:id",
                name: "DetailVMInventoryOff",
                component: () => import("../views/DetailVMInventoryOff.vue"),
                meta:{requiresAuth: true, allowedRoles: [2, 3, 5]}
            },

            {
                path: '/vendor',
                name: 'Vendor',
                component: () => import('../views/Vendor.vue'),
                meta:{requiresAuth: true, allowedRoles: [2]}
            },
            
            //superadmin
            {
                path: "/management-user",
                name: "ManagementUser",
                component: () => import("../views/superadmin/User.vue"),
                meta:{requiresAuth: true, allowedRoles: [99]}
            },
            {
                path: "/role",
                name: "ManagementRole",
                component: () => import("../views/superadmin/Role.vue"),
                meta:{requiresAuth: true, allowedRoles: [99]}
            },
            {
                path: "/audit-trail",
                name: "AuditTrail",
                component: () => import("../views/superadmin/DepositAudit.vue"),
                meta:{requiresAuth: true, allowedRoles: [99]}
            },
            {
                path: "/audit-trail/:id",
                name: "AuditTrailDetail",
                component: () => import("../views/superadmin/AuditTrail.vue"),
                meta:{requiresAuth: true, allowedRoles: [99]}
            },
            {
                path: '/forbiden-access',
                name: 'forbiden access',
                component: () => import('../views/ForbidenAccess.vue')
            },
        ]
    },
    // {
    //     path: "/recognitionTemp",
    //     name: "faceRecognitionTemp",
    //     component: () => import("../components/withdrawal/FaceRecognitionTemp.vue"),
    // },
    { path: "*", component: () => import("../components/utilsLayout/PageNotFound.vue") },
]

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});


router.beforeEach((to, from, next)=>{
    const isLoggedIn = !!sessionStorage.getItem('token');
    const userRole = parseInt(sessionStorage.getItem('role'))
    if(!isLoggedIn && to.path !== '/login'){
        return next('/login')
    }

    if(to.meta.requiresAuth){
        const allowed = to.meta.allowedRoles || []
        if(!allowed.includes(userRole)){
            return next('/forbiden-access')
        }
    }

    next()
})

export default router;